import React from 'react';

import Skeleton from '@mui/material/Skeleton/Skeleton';

type ButtonSkeletonProps = {
  isInstallmentEnabledAndType?: boolean;
};

export const AddToCartButtonSkeleton: React.FC<ButtonSkeletonProps> = ({isInstallmentEnabledAndType}) => {
  const width = isInstallmentEnabledAndType ? '100%' : 120;
  return <Skeleton animation="wave" variant="rounded" width={width} height={32} />;
};

AddToCartButtonSkeleton.displayName = 'AddToCartButtonSkeleton';
